import { createServerErrorAsToastr } from 'common/server-errors-toastr';
import UserActions from 'states/resources/users/actions';

const actions = {
    /**
     * Open the delete confirmation modal for a user row.
     * Pass the full user so child-org cache delete can use `user.organization`
     * without a second lookup or GraphQL refetch.
     *
     * @param {Object} user - User record from the admin users table (must include `id`)
     */
    open(user) {
        return dispatch => {
            dispatch({
                type: 'DELETE_USER_MODAL__OPEN_MODAL',
                payload: { user },
            });
        };
    },
    close() {
        return dispatch => {
            dispatch({
                type: 'DELETE_USER_MODAL__CLOSE_MODAL',
            });
        };
    },
    /**
     * Delete the stored user, then notify the parent via `refreshUsers`.
     * Child-org passes a delete marker (`_deleted: true`) so `applySavedUser`
     * can prune `usersByOrgId` / All list from cache only.
     *
     * @param {Function} [refreshUsers] - Parent refresh callback; may receive a delete marker
     */
    delete(refreshUsers) {
        return async (dispatch, getState) => {
            const user = getState()?.deleteUserModal?.user;
            const userId = user?.id;
            dispatch({
                type: 'DELETE_USER_MODAL__DELETE_START',
            });
            try {
                await dispatch(UserActions.delete(userId));
                dispatch({
                    type: 'DELETE_USER_MODAL__DELETE_SUCCESS',
                });
                dispatch(actions.close());
                // Keep id + organization on the marker so cache updates one org bucket only
                if (typeof refreshUsers === 'function') {
                    refreshUsers(
                        userId
                            ? {
                                  id: userId,
                                  organization: user.organization,
                                  _deleted: true,
                              }
                            : undefined
                    );
                }
            } catch (error) {
                dispatch({
                    type: 'DELETE_USER_MODAL__DELETE_FAIL',
                });
                createServerErrorAsToastr(error);
            }
        };
    },
};

export default actions;
